var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 19",
    fill: "#212121",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.357 19v-8.915H0v-3.21h2.357V4.133C2.357 1.979 3.75 0 6.96 0c1.299 0 2.26.125 2.26.125l-.076 2.997s-.98-.01-2.05-.01c-1.156 0-1.342.534-1.342 1.419v2.344h3.484l-.152 3.21H5.751V19H2.357z"
  })));
}

export default SvgFb;